export default "__VITE_ASSET__e33c7e62__"